import React, { PureComponent } from 'react'
import { reduxForm } from 'redux-form'
import { Row, Col, Panel, Table } from 'react-bootstrap'
import { Element } from 'react-scroll'
import { dossierTypes as dossierTypesConstant } from '../../../constants/dossier/common/dossierTypes'
import { compareObjects } from '../../../util/utils'
import { getComponentsPermisions } from '../../../util/permisionFunctions'
import EditableTable from '../../commons/editableTable/EditableTable'
import StatusHeaderPage from '../../../containers/dossierHistorical/common/StatusHeaderPage'
import ButtonsHeader from '../common/ButtonsHeader'
import ButtonsSidebar from '../../dossiers/common/ButtonsSidebar'
import RejectCommentModal from '../common/RejectCommentModal'
import { buttonsHeader } from '../../../constants/dossier/common/buttonsHeader'
import { urgencyTypesClass, permissions } from '../../../constants/backendIds'
import DocumentaryManagementPage from '../../../containers/dossierHistorical/common/DocumentaryManagementPage'
import AuditInfo from '../../dossiers/common/audit/AuditInfo'
import { Link } from 'react-router-dom'
import TrackingContainer from '../../../containers/tracking/trackingContainer'
import { TrackedPages } from '../../../constants/tracking/TrackedPages'
import Vehicle from '../common/Vehicle'
import { buttonsSidebar } from '../../../constants/dossier/common/buttonsSidebar'
import ServiceComponent from '../service/ServiceComponent'

class ServiceHistorical extends PureComponent {
  constructor () {
    super()
    this.state = {
      modalOpen: true,
      summaryOpen: true,
      showRejectCommentModal: false,
      activeTabConfiguration: null,
      headerTabConfiguration: null,
      loaded: false,
      componentsConfiguration: {
        downloadDocumentsButton: null,
        vehicle: null,
        bservice: null
      },
      isVehicleLoaded: false
    }
    this.goBack = this.goBack.bind(this)
  }

  goBack () {
    this.props.actions.setActiveTab(buttonsHeader.datos_expediente)
    this.props.history.goBack()
  }

  toggleRejectCommentModal (showRejectCommentModal) {
    this.setState({ showRejectCommentModal })
  }

  onClickRelatedDossierColumn (columnCode) {
    let columnCodeOrder = '+' + columnCode
    if (columnCodeOrder === this.props.relatedDossiersOrderBy) {
      columnCodeOrder = '-' + columnCode
    }
    this.props.actions.fetchFilteredRelatedDossier(this.props.dossier.dossierId, columnCodeOrder, true)
  }

  getRelatedDossierColumnIcon (columnCode) {
    if ('+' + columnCode === this.props.relatedDossiersOrderBy) {
      return 'ico-sort-selected-asc'
    } else if ('-' + columnCode === this.props.relatedDossiersOrderBy) {
      return 'ico-sort-selected-desc'
    } else {
      return 'ico-sort'
    }
  }

  fetchServiceDossierPromise (dossierId) {
    return new Promise((resolve, reject) => {
      return this.props.actions.fetchServiceDossier(dossierId, resolve, reject, true)
    })
  }

  initializePermisions (props) {
    const componentKeys = Object.keys(this.state.componentsConfiguration)
    const newState = getComponentsPermisions(props.dossier.viewConfiguration.tabsConfiguration, props.activeTab, componentKeys)
    this.setState({ ...this.state, ...newState })
  }

  componentDidMount () {
    this.props.actions.restartServiceDossierState()
    this.fetchServiceDossierPromise(this.props.match.params.dossierId).then(() => {
      const form = { ...this.props.dossier }
      this.props.initialize(form)
      this.initializePermisions(this.props)
      this.props.trackVisitPage({
        documentTitle: TrackedPages.SERVICE_HISTORICAL,
        organizedUnitId: this.props.dossier.organizedUnitId,
        href: window.location.href
      })
      this.props.actions.fetchSameLevelOusCombo(this.props.dossier.organizedUnitId, null)
      this.setState({ loaded: true })
      this.props.actions.fetchCustomFields(this.props.dossier.dossierSubTypeId)
    })
  }

  getSnapshotBeforeUpdate (prevProps) {
    if (this.props.dossier && this.props.dossier.viewConfiguration && this.props.dossier.viewConfiguration.tabsConfiguration && !compareObjects(prevProps.dossier.viewConfiguration.tabsConfiguration || {}, this.props.dossier.viewConfiguration.tabsConfiguration, true)) {
      this.initializePermisions(this.props)
    }
    if (this.props.dossier.dossierId && prevProps.activeTab !== this.props.activeTab) {
      this.initializePermisions(this.props)
    }
    return this.props
  }

  componentDidUpdate (prevProps) {
    if ((this.props.showManagementModal && !prevProps.showManagementModal) || (this.props.match.params.dossierId !== prevProps.match.params.dossierId)) {
      if (this.props.match.params.dossierId !== prevProps.match.params.dossierId) {
        this.props.actions.restartServiceDossierState()
        this.props.actions.setScrollTo(buttonsSidebar.bservice)
        this.props.actions.setActiveSection(buttonsSidebar.bservice)
        this.props.actions.setActiveTab(buttonsHeader.datos_expediente)
        this.props.actions.closeAddOrEditDocumentModal()
      }

      if (this.props.match.params.dossierId) {
        this.fetchServiceDossierPromise(this.props.match.params.dossierId).then(() => {
          const form = { ...this.props.dossier }
          this.props.initialize(form)
          this.initializePermisions(this.props)
          this.setState({ loaded: true })
        })
      }
    }

    if (this.props.dossier && this.props.dossier.dossierId && this.props.statusHeaderHeight && this.props.activeSection !== prevProps.activeSection) {
      switch (this.props.activeSection) {
        case buttonsSidebar.bservice:
          this.setState({ summaryOpen: true })
          break
      }
      this.props.actions.setScrollTo(this.props.activeSection)
      this.props.actions.setActiveSection(false)
    }

    const firstCustomFieldsLoad = prevProps.dossier.customFieldsByComponent?.length < this.props.dossier.customFieldsByComponent?.length
    if (firstCustomFieldsLoad) {
      let customFields = {}
      if (this.props.dossier.customFieldsValues) {
        this.props.dossier.customFieldsValues.map(x => {
          customFields[x.key] = x.value
        })
      }
      const form = {
        ...this.props.dossier,
        customFields: customFields
      }
      this.props.initialize(form)
    }
  }

  componentWillUnmount () {
    this.props.actions.setActiveSection(buttonsSidebar.bservice)
    this.props.actions.setScrollTo(null)
    this.props.actions.resetButtonsHeader()
    this.props.actions.closeAddOrEditDocumentModal()
    this.props.actions.restartServiceDossierState()
  }

  handleToUpdateComponent (component) {
    if (component.isVehicleLoaded === false || buttonsSidebar.vehicle === component) this.setState({ isVehicleLoaded: true })
    this.props.actions.setScrollTo(component)
  }

  togglePanel () {
    if (this.state.summaryOpen) {
      this.props.actions.setActiveSection(false)
    }
    this.setState({ summaryOpen: !this.state.summaryOpen })
  }

  render () {
    const {
      t, dossier, pristine, activeTab, buttonsHeaderHeight, statusHeaderHeight, windowWidth, documentExport, vehicleProps, combos, activeSection, change,
      dossier: {
        dossierId, header, checkListHeader, comments, viewConfiguration, dossierRelatedDossiers, auditInfo, dossierSubTypeId, dossierParentId,
        vehicleComponent: { vehicleId },
        viewConfiguration: { buttonsPermission = [] }
      },
      actions: {
        openDocumentModal, setActiveTab, setButtonsHeaderHeight, resetButtonsHeader, setActiveSection, setScrollerOptions,
        refreshAuditInfo, saveSelectedDocuments, fetchServiceDossierVehicleHistorical, fetchComboOrigin, fetchComboDestination, fecthFamily,
        setEntitySubTypeId, fetchAuditDetails, fetchAuditDetailsModal, fetchDocumentsGroupedAuditDetails, fetchDocumentsGroupedAuditDetailsModal,
        fetchEntitySubTypeCombo,
        fetchEntityFilterSubTypeCombo
      }
    } = this.props

    if (!dossierId) return null
    const tKey = 'DOSSIER_COMPONENTS.'
    const panelsPaddingTop = statusHeaderHeight + buttonsHeaderHeight - 82
    const saveServiceDossierPermission = buttonsPermission.includes('service_dossier_save')
    return (
      <div className="dossier-purchase-container">
        <RejectCommentModal
          t={t}
          showModal={this.state.showRejectCommentModal}
          actions={{
            closeModal: () => this.toggleRejectCommentModal(false)
          }}
        />
        <Col sm={12} className="add-dossier-wrapper dossier">
          <StatusHeaderPage
            headerData={header}
            stages={checkListHeader}
            dossierType={dossierTypesConstant.service}
            headerTabConfiguration={this.state.headerTabConfiguration}
            goBack={this.goBack}
            loadedDossier={this.state.loaded}
          />
        </Col>
        <form autoComplete="off">
          <div className="row-header-buttons">
            <div className="buttons-header-box">
              <ButtonsHeader
                t={t}
                pristine={pristine}
                actions={{
                  openDocumentModal: () => openDocumentModal(dossierId, dossierTypesConstant.service, pristine, 1, true),
                  setActiveTab,
                  setButtonsHeaderHeight,
                  resetButtonsHeader,
                  setScrollerOptions
                }}
                viewConfiguration={viewConfiguration}
                dossierId={this.props.match.params.dossierId}
                dossierType={dossierTypesConstant.service}
                activeTab={activeTab}
                marginTop={statusHeaderHeight}
                windowWidth={windowWidth}
              />
            </div>
          </div>
          {
            activeTab === buttonsHeader.datos_expediente && this.state.activeTabConfiguration && this.state.activeTabConfiguration.permission > permissions.hidden && (
              <Row className="sales-panel dossier-panel">
                <Col sm={3} className="col-row expediente-menu-izq">
                  <ButtonsSidebar
                    t={t}
                    dossierId={dossierId}
                    historical={true}
                    handleToUpdateComponent={this.handleToUpdateComponent.bind(this)}
                    pristine={pristine}
                    actions={{ setActiveSection, fetchServiceDossierVehicleHistorical }}
                    dossierType={dossierTypesConstant.service}
                    marginTop={statusHeaderHeight}
                    dossierSubTypes={dossierSubTypeId}
                    buttonsHeaderHeight={buttonsHeaderHeight}
                    tabConfiguration={this.state.activeTabConfiguration}
                    isVehicleLoaded={this.state.isVehicleLoaded}
                  />
                </Col>
                <Col sm={9} className="col-row contenido-paneles-expediente">
                  <Col className="panels-wrapper dossier fixed" style={{ paddingTop: panelsPaddingTop }}>
                    {this.state.componentsConfiguration.bservice && this.state.componentsConfiguration.bservice.permission > permissions.hidden && (
                      <Element name={buttonsSidebar.bservice}>
                        <ServiceComponent
                          dossier={dossier}
                          t={t}
                          summaryOpen={this.state.summaryOpen}
                          actions= {{
                            setActiveTab,
                            togglePanel: () => this.togglePanel(),
                            setEntitySubTypeId,
                            fetchEntitySubTypeCombo,
                            fetchEntityFilterSubTypeCombo,
                            change,
                            setActiveSection
                          }}
                          combos={combos}
                          dossierType={dossierTypesConstant.service}
                          componentConfiguration={this.state.componentsConfiguration.bservice}
                          readOnlyFields={true}
                          customFields={this.props.dossier.customFieldsByComponent.find(x => x.componentCode === buttonsSidebar.bservice)?.customFields}
                        />
                      </Element>
                    )}
                    {this.state.componentsConfiguration.vehicle && this.state.componentsConfiguration.vehicle.permission > permissions.hidden && (
                      <Element name={buttonsSidebar.vehicle}>
                        <Vehicle
                          parentDossierType={{
                            isPaperwork: false,
                            isSales: false,
                            isPurchase: false,
                            isRegistrationDelivery: false,
                            isService: true

                          }}
                          actions={{
                            fetchComboOrigin,
                            fetchComboDestination,
                            fetchServiceDossierVehicleHistorical,
                            fecthFamily,
                            setActiveSection
                          }}
                          t={t}
                          dossierId={dossierId}
                          dossierType={dossierTypesConstant.service}
                          handleToUpdateComponent={this.handleToUpdateComponent.bind(this)}
                          isVehicleLoaded={this.state.isVehicleLoaded}
                          vehicleProps={vehicleProps}
                          dossierSubType={dossierSubTypeId}
                          dossierParentId={dossierParentId}
                          dossierWithVehicle={!!vehicleId}
                          combos={combos}
                          readOnlyFields={!saveServiceDossierPermission || !!dossierParentId}
                          open={activeSection === buttonsSidebar.vehicle}
                          componentConfiguration={this.state.componentsConfiguration.vehicle}
                          organizedUnitId={dossier.organizedUnitId}
                          customFields={this.props.dossier.customFieldsByComponent.find(x => x.componentCode === buttonsSidebar.vehicle)?.customFields}
                        />
                      </Element>
                    )}
                  </Col>
                </Col>
              </Row>
            )}
          {activeTab === buttonsHeader.gestor_documental && this.state.activeTabConfiguration && this.state.activeTabConfiguration.permission > permissions.hidden && (
            <Row className="sales-panel dossier-panel panel-expedientes-relacionados">
              <Col sm={12} className="col-row" style={{ paddingTop: panelsPaddingTop }}>
                <DocumentaryManagementPage
                  dossier={dossier}
                  dossierType={dossierTypesConstant.service}
                  saveSelectedDocuments={saveSelectedDocuments}
                  documentExport={documentExport}
                  combos={this.props.combos}
                  isHistorical={true}
                  tabConfiguration={this.state.activeTabConfiguration}
                  downloadButtonPermission={this.state.activeTabConfiguration.componentsConfiguration.downloadDocumentsButton}
                />
              </Col>
            </Row>
          )}
          {activeTab === buttonsHeader.expedientes_relacionados && this.state.activeTabConfiguration && this.state.activeTabConfiguration.permission > permissions.hidden && (
            <Row className="sales-panel dossier-panel panel-expedientes-relacionados">
              <Col sm={12} className="col-row" style={{ paddingTop: panelsPaddingTop }}>
                <Col sm={6} className="col-row">
                  <h4><i className="ico-relacion" /> Expedientes relacionados</h4>
                </Col>
                <Col sm={12} className="col-row">
                  <Table hover responsive className="simple-table dashboard-tasks-table" id="related-dossiers-table">
                    <thead>
                      <tr>
                        <th onClick={this.onClickRelatedDossierColumn.bind(this, 'urgencyType')}>
                          <i className={this.getRelatedDossierColumnIcon('urgencyType')} />
                        </th>
                        <th onClick={this.onClickRelatedDossierColumn.bind(this, 'number')}>
                          Número de expediente <i className={this.getRelatedDossierColumnIcon('number')} />
                        </th>
                        <th onClick={this.onClickRelatedDossierColumn.bind(this, 'organizedUnit')}>
                          UO <i className={this.getRelatedDossierColumnIcon('organizedUnit')} />
                        </th>
                        <th onClick={this.onClickRelatedDossierColumn.bind(this, 'dossierSubType')}>
                          Subtipo <i className={this.getRelatedDossierColumnIcon('dossierSubType')} />
                        </th>
                        <th onClick={this.onClickRelatedDossierColumn.bind(this, 'stage')}>
                          Estado <i className={this.getRelatedDossierColumnIcon('stage')} />
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        dossierRelatedDossiers.map((relatedDossier, idx) => {
                          return (
                            <tr key={idx}>
                              <td>
                                <span className={'color-point ' + urgencyTypesClass[relatedDossier.urgencyType]}></span>
                              </td>
                              <td>
                                {
                                  relatedDossier.urlToNavigate ? (
                                    <Link to={`/dossier${relatedDossier.urlToNavigate}`}>
                                      {relatedDossier.number}
                                    </Link>
                                  ) : relatedDossier.number
                                }
                              </td>
                              <td>{relatedDossier.organizedUnit}</td>
                              <td>{relatedDossier.dossierSubType}</td>
                              <td>{relatedDossier.stage}</td>
                            </tr>
                          )
                        })
                      }
                    </tbody>
                  </Table>
                </Col>
              </Col>
            </Row>
          )}
          {
            activeTab === buttonsHeader.actividad_expediente && this.state.activeTabConfiguration && this.state.activeTabConfiguration.permission > permissions.hidden && (
              <Row className="sales-panel dossier-panel panel-actividad-expediente">
                <Col sm={12} className="col-row" style={{ paddingTop: panelsPaddingTop }}>
                  <AuditInfo
                    auditInfo={auditInfo}
                    dossierType={dossierTypesConstant.service}
                    actions={{ refreshAuditInfo, fetchAuditDetails, fetchAuditDetailsModal, fetchDocumentsGroupedAuditDetails, fetchDocumentsGroupedAuditDetailsModal }}
                    dossier={dossier}
                    historical={true}
                    t={t}
                  />
                </Col>
              </Row>
            )
          }
          {
            activeTab === buttonsHeader.observaciones && this.state.activeTabConfiguration && this.state.activeTabConfiguration.permission > permissions.hidden && (
              <Row className="sales-panel dossier-panel panel-observaciones-expediente">
                <Col sm={12} className="col-row" style={{ paddingTop: panelsPaddingTop }}>
                  <Col sm={6} className="col-row">
                    <h4><i className="ico-bocadillo" onClick={() => { this.setState({ modalOpen: !this.state.modalOpen }) }} /> {t(`${tKey}COMMENTS.TITLE_PANEL`)}</h4>
                  </Col>
                  <Col sm={12} className="col-row">
                    <Panel expanded={this.state.modalOpen} onToggle={() => { }}>
                      <Panel.Collapse>
                        <Row>
                          <EditableTable
                            t={t}
                            columnsConfig={
                              [
                                { th: t(`${tKey}COMMENTS.USER_NAME`), key: 'userName', nonEditable: true },
                                { th: t(`${tKey}COMMENTS.COMMENT_TYPE`), key: 'commentType', nonEditable: true },
                                { th: t(`${tKey}COMMENTS.TEXT`), key: 'text', style: { width: '30%' } },
                                { th: t(`${tKey}COMMENTS.CREATION_DATE`), key: 'creationDate', nonEditable: true }
                              ]
                            }
                            dossierType={dossierTypesConstant.service}
                            editableObjectsArray={comments}
                            readOnlyFields={true}
                          />
                        </Row>
                      </Panel.Collapse>
                    </Panel>
                  </Col>
                </Col>
              </Row>
            )
          }
        </form>
      </div>
    )
  }
}

var decoratedComponent = TrackingContainer(ServiceHistorical, false)

export default reduxForm({
  form: 'service_dossier'
})(decoratedComponent)
